import { IconCheck, IconReload, IconX } from '@tabler/icons-react-native';
import { Event, track } from 'app/lib/analytics';
import { View } from 'react-native';
import { HubButton, hubColors, styles } from '../components';
import { OfferHubTutorialActions } from './offer-hub-tutorial-actions';

import type { OfferHubState } from '../hooks';

export function OfferHubDock(props: Parameters<typeof OfferHubDockContent>[0]) {
  return (
    <View style={styles.dock}>
      <OfferHubDockContent {...props} />
    </View>
  );
}

function OfferHubDockContent({
  loaded,
  replayingSwipeTutorial,
  swipeTutorialStep,
  swipeTutorialCard,
  t,
  fetchingRound,
  showError,
  setSwipeTutorialStep,
  startList,
  completed,
  close,
  swiping,
  swipeCard,
  currentItem,
  inProgress,
}: Pick<
  OfferHubState,
  | 'loaded'
  | 'replayingSwipeTutorial'
  | 'swipeTutorialStep'
  | 'swipeTutorialCard'
  | 't'
  | 'fetchingRound'
  | 'showError'
  | 'setSwipeTutorialStep'
  | 'startList'
  | 'completed'
  | 'close'
  | 'swiping'
  | 'swipeCard'
  | 'currentItem'
  | 'inProgress'
>) {
  if (!loaded) return null;
  if (replayingSwipeTutorial)
    return (
      <OfferHubTutorialActions
        swipeTutorialStep={swipeTutorialStep}
        swipeTutorialCard={swipeTutorialCard}
        t={t}
        fetchingRound={fetchingRound}
        showError={showError}
        setSwipeTutorialStep={setSwipeTutorialStep}
        startList={startList}
      />
    );
  if (completed)
    return (
      <View style={styles.buttonRow}>
        <HubButton
          style={styles.flex}
          tone="outline"
          onPress={() => {
            track(Event.OfferHubFinishPressed);
            close();
          }}
        >
          {t('finish')}
        </HubButton>
        <HubButton
          style={styles.flex}
          tone="teal"
          disabled={fetchingRound || showError}
          prefix={<IconReload size={24} color="#FFFFFF" />}
          onPress={() => {
            track(Event.OfferHubContinuePressed);
            void startList(true);
          }}
        >
          {t('restart')}
        </HubButton>
      </View>
    );
  if (swiping)
    return (
      <View style={styles.buttonRow}>
        <HubButton
          testID="offer-hub-reject"
          style={styles.flex}
          tone="outline"
          disabled={showError}
          prefix={<IconX size={24} color={hubColors.ink} />}
          onPress={() => swipeCard.current?.swipe('reject')}
        >
          {t('reject')}
        </HubButton>
        <HubButton
          testID="offer-hub-accept"
          style={styles.flex}
          tone="teal"
          disabled={showError}
          accessibilityHint={t('acceptHint')}
          prefix={<IconCheck size={24} color="#FFFFFF" />}
          onPress={() => swipeCard.current?.swipe('accept')}
        >
          {t('accept')}
        </HubButton>
      </View>
    );
  return (
    <HubButton
      disabled={fetchingRound || showError}
      onPress={() => {
        void startList(!currentItem);
      }}
    >
      {t(currentItem ? (inProgress ? 'resumeList' : 'startList') : 'retryLoading')}
    </HubButton>
  );
}
